import { Pipe, PipeTransform } from '@angular/core';
import { Job_Status } from '@sites/data-hmm/hmm-job';

@Pipe({
  name: 'dashboardUiJobStatus',
  standalone: true,
})
export class JobStatusPipe implements PipeTransform {
  transform(status?: Job_Status): string {
    return NAMES[status || Job_Status.UNKNOWN];
  }
}

const NAMES: { [key in Job_Status]: string } = {
  [Job_Status.UNKNOWN]: 'Unknown',
  [Job_Status.RUNNING]: 'Running',
  [Job_Status.SUCCESS]: 'Success',
  [Job_Status.FAILURE]: 'Failure',
  [Job_Status.CANCELLED]: 'Cancelled',
};
